import { create } from "zustand";

type State = {
  nome: string | null;
  status?: number;
};
type Action = {
  setNome: (nome: string | undefined) => void;
  setStatus: (status: number) => void;
  clearFilters: () => void;
};
export const useTermoEpiListaFilters = create<State & Action>((set) => ({
    nome: "",
    status: 1,
    setStatus: (status) => set({ status }),
    setNome: (nome) => set({ nome }),
    clearFilters: () => set({
        nome: "",
        status: 1,
    }),
}));
export const initialTermoFiltersValues: State = {
    nome: "",
    status: 1,

}
